import React from 'react';
import {
  WelcomeOfferList,
  BonusConditions,
  TermsAndConditions,
  WelcomeBonusDescription,
  WelcomeBonusTitle,
  WelcomeBonusBtn
} from './components';
import { BonusInfoWrapper } from './styles';

export const BonusInfo = ({ dataWelcomeAvailable }) => {
  return (
    <BonusInfoWrapper>
      <WelcomeBonusTitle />
      <WelcomeBonusDescription />
      <WelcomeOfferList />
      <BonusConditions />
      <TermsAndConditions />
      <WelcomeBonusBtn dataWelcomeAvailable={dataWelcomeAvailable}/>
    </BonusInfoWrapper>
  );
};